import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
  CreditNote, CreditNoteCreateDTO, CreditNotePage, CreditableLine, CreditNoteRefund, CreditNoteRefundCreateDTO,
} from '../interfaces/sales/creditNote.interface';

export const CreditNoteService = {
  create: async (dto: CreditNoteCreateDTO): Promise<CreditNote> =>
    (await axios.post(ENDPOINTS.CREDIT_NOTE.CREATE, dto)).data,
  listByInstitution: async (page = 0, size = 10): Promise<CreditNotePage> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.CREDIT_NOTE.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  listByInvoice: async (invoiceId: string): Promise<CreditNote[]> =>
    (await axios.get(ENDPOINTS.CREDIT_NOTE.LIST_BY_INVOICE(invoiceId))).data,
  creditableLines: async (invoiceId: string): Promise<CreditableLine[]> =>
    (await axios.get(ENDPOINTS.CREDIT_NOTE.CREDITABLE_LINES(invoiceId))).data,
  getById: async (id: string): Promise<CreditNote> =>
    (await axios.get(ENDPOINTS.CREDIT_NOTE.GET_BY_ID(id))).data,
  voidNote: async (id: string, reason: string): Promise<CreditNote> =>
    (await axios.post(ENDPOINTS.CREDIT_NOTE.VOID(id), { reason })).data,
  listRefunds: async (id: string): Promise<CreditNoteRefund[]> =>
    (await axios.get(ENDPOINTS.CREDIT_NOTE.REFUNDS(id))).data,
  refund: async (id: string, dto: CreditNoteRefundCreateDTO): Promise<CreditNoteRefund> =>
    (await axios.post(ENDPOINTS.CREDIT_NOTE.REFUNDS(id), dto)).data,
  reverseRefund: async (refundId: string): Promise<CreditNoteRefund> =>
    (await axios.post(ENDPOINTS.CREDIT_NOTE.REVERSE_REFUND(refundId))).data,
  downloadPdf: async (id: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.CREDIT_NOTE.PDF(id), { responseType: 'blob' })).data,
  email: async (id: string): Promise<void> => {
    await axios.post(ENDPOINTS.CREDIT_NOTE.EMAIL(id));
  },
};
